import { useState } from "react";
import { UserCheckIcon } from "lucide-react";
import { Checkbox } from "../../../../components/UI/Checkbox";
import { Button } from "../../../../components/UI/Button";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "../../../../components/UI/Popover";

const StaffAssignmentPopover = ({
  user,
  selectedShop,
  selectedChat,
  staffs,
  onAssignStaffClick,
}) => {
  const [open, setOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");

  // Filter staffs based on search query
  const filteredStaffs = staffs.filter((staff) =>
    staff.name.toLowerCase().includes(searchQuery.toLowerCase()),
  );

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button
          variant="ghost"
          size="icon"
          className="p-2 rounded-full hover:bg-secondary transition-colors"
          aria-label="Phân công nhân viên"
        >
          <UserCheckIcon size={20} className="text-green-600" />
        </Button>
      </PopoverTrigger>
      <PopoverContent
        className="w-72 p-4 bg-white rounded-lg shadow-md border border-gray-100"
        align="end"
      >
        <div className="space-y-4">
          <h3 className="font-semibold text-gray-700">Phân công nhân viên</h3>

          <div className="relative">
            <input
              type="text"
              placeholder="Tìm nhân viên..."
              className="w-full p-2 border border-gray-200 rounded-md text-sm focus:outline-none focus:ring-1 focus:ring-green-500"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
            />
          </div>

          <div className="max-h-60 overflow-y-auto pr-1 space-y-2">
            {filteredStaffs.length > 0 ? (
              filteredStaffs.map((staff) => (
                <div
                  key={staff._id}
                  className="flex items-center space-x-3 p-2 hover:bg-gray-50 rounded-md transition-colors"
                >
                  <Checkbox
                    id={`staff-${staff._id}`}
                    checked={selectedChat.staffIds?.includes(staff._id)}
                    onCheckedChange={(checked) =>
                      onAssignStaffClick(checked === true, staff)
                    }
                    disabled={
                      user?.role?.includes("admin")
                        ? false
                        : selectedChat.staffIds?.includes(staff._id)
                          ? !user?.shopRoles
                              ?.find((sr) => sr.shopId === selectedShop._id)
                              ?.permissions?.includes("remove_manage_contact")
                          : !user?.shopRoles
                              ?.find((sr) => sr.shopId === selectedShop._id)
                              ?.permissions?.includes("add_manage_contact")
                    }
                    className="data-[state=checked]:bg-green-600 data-[state=checked]:border-green-600"
                  />
                  <label
                    htmlFor={`staff-${staff._id}`}
                    className="flex items-center space-x-2 flex-1 cursor-pointer text-sm"
                  >
                    {staff.avatar && (
                      <div className="h-7 w-7 rounded-full overflow-hidden">
                        <img
                          src={staff.avatar}
                          alt={staff.name}
                          className="h-full w-full object-cover"
                        />
                      </div>
                    )}
                    <span>{staff.name}</span>
                  </label>
                </div>
              ))
            ) : (
              <p className="text-center text-gray-400 py-2">
                Không tìm thấy nhân viên
              </p>
            )}
          </div>
        </div>
      </PopoverContent>
    </Popover>
  );
};

export default StaffAssignmentPopover;
